var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M14.6153 3.22013C15.1228 2.71256 15.1228 1.88826 14.6153 1.38068C14.1077 0.873106 13.2834 0.873106 12.7758 1.38068L8.5 5.66055L4.22013 1.38474C3.71256 0.877167 2.88826 0.877167 2.38068 1.38474C1.87311 1.89232 1.87311 2.71662 2.38068 3.22419L6.66055 7.5L2.38474 11.7799C1.87717 12.2874 1.87717 13.1117 2.38474 13.6193C2.89232 14.1269 3.71662 14.1269 4.22419 13.6193L8.5 9.33945L12.7799 13.6153C13.2874 14.1228 14.1117 14.1228 14.6193 13.6153C15.1269 13.1077 15.1269 12.2834 14.6193 11.7758L10.3394 7.5L14.6153 3.22013Z",
          fill: "#FF3B30",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }